/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  useReducer,
  useRef,
  useEffect,
  useCallback,
  ReducerState,
  Dispatch,
  ReducerAction,
  Reducer,
} from 'react'

export const useSafeReducer = <R extends Reducer<any, any>, I>(
  reducer: R,
  initializerArg: I & ReducerState<R>
): [ReducerState<R>, Dispatch<ReducerAction<R>>] => {
  const [state, dispatch] = useReducer(reducer, initializerArg)
  const mounted = useRef<boolean>()

  useEffect(() => {
    mounted.current = true

    return () => {
      mounted.current = false
    }
  }, [])

  const safeDispatch: Dispatch<ReducerAction<R>> = useCallback(args => {
    if (mounted.current) {
      dispatch(args)
    }
  }, [])

  return [state, safeDispatch]
}
